
import React, { useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import NewSideBar from '../../components/NewSideBar/NewSideBar';
import { useParams } from 'react-router-dom';
import HomePage from './HomePage';
import { useDispatch, useSelector } from 'react-redux';
import { getAllReportsJobsListSlice } from '../../store/redux/slices/enterpriseSlice';
import ActiveEnterprise from './ActiveEnterprise';
import { getAllAlert } from '../../store/redux/slices/alertSlice';


const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 20% 80%;
  width: 100%;
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
  // background:red;
`;

const EnterpriseHomePage = () => {

    const { screenId } = useParams();
    const { jobsList } = useSelector((state) => state.enterprise)

    console.log(screenId, jobsList, "screenId");
    const dispatch = useDispatch();
    const getJobData = async () => {
        // setJobList(null);
        const data = await dispatch(getAllReportsJobsListSlice());
        // console.log(data?.payload);
        // setJobList(data?.payload);
    };
    useEffect(() => {
        getJobData();
        dispatch(getAllAlert());
    }, []);

    const activeSubTabs = [];
    const TabScreen = useMemo(() => {
        const base = { home: <HomePage />, view: <ActiveEnterprise /> };
        jobsList?.forEach((topic) => {
            base[`job_${topic.job_id}`] = <ActiveEnterprise job_id={topic.job_id} />;
        });
        return base;
    }, [jobsList]);

    jobsList && jobsList?.forEach((topic) => {
        TabScreen[`job_${topic.job_id}`] = <ActiveEnterprise job_id={topic.job_id} />;

        const subTab = {
            id: topic.job_id,
            val: topic.title,
            path: `/enterprise/job_${topic.job_id}`,
            channel: 'enterprise',
        };
        activeSubTabs.push(subTab);

    });

    const tabs = [
        {
            id: 1,
            val: 'Enterprise Reports',
            subTabs: activeSubTabs,
            showHibernate:true
        },
    ];



    const generateActiveTab = () => {
        if (screenId === 'home') {
            return 1;
        } else if (screenId === 'create') {
            return { tab: 1, subTab: '1a' };
        } else if (screenId === 'view') {
            return { tab: 1, subTab: '1a' };
        }
        console.log(screenId, "screenId");

        for (let i = 0; i < activeSubTabs.length; i++) {
            if (screenId === `job_${activeSubTabs[i].id}`) {
                return { tab: 1, subTab: activeSubTabs[i].id };
            }
        }
    };

    const wrapperRef = useRef(null);
    useEffect(() => {
        if (wrapperRef.current) {
            wrapperRef.current.scrollTo({ top: 0, behavior: 'smooth' }); // 👈 scroll the wrapper
        }
    });
    return (
        <Wrapper ref={wrapperRef}>
            <NewSideBar
                headerName='Enterprise Data'
                tabs={tabs}
                initialActiveTab={generateActiveTab()}
                buttonTitle={'New Topic'}
            />
            {TabScreen[screenId]}
        </Wrapper>
    );
};


export default EnterpriseHomePage;